/** Terrain follow (spec §5.2, §5.3). */
import type { Dtm, LngLat } from './types';

/** Waypoint height relative to takeoff: the AGL plus the terrain rise since the takeoff point; plain AGL where terrain is unknown. */
export function heightAt(dtm: Dtm | null, takeoffElev: number | null, p: LngLat, agl: number): number {
  if (!dtm || takeoffElev === null) return agl;
  const t = dtm.sample(p[0], p[1]);
  return t === null ? agl : agl + t - takeoffElev;
}

/** Douglas-Peucker over the (x, h) profile of one line; the kept indices become waypoints. */
export function simplifyIndices(xs: number[], hs: number[], tol: number): number[] {
  const n = xs.length;
  if (n <= 2) return Array.from({ length: n }, (_, i) => i);
  const keep = new Set<number>([0, n - 1]);
  const stack: [number, number][] = [[0, n - 1]];
  while (stack.length) {
    const [a, b] = stack.pop()!;
    let worst = -1;
    let worstDev = tol;
    for (let i = a + 1; i < b; i++) {
      const t = (xs[i] - xs[a]) / (xs[b] - xs[a] || 1);
      const dev = Math.abs(hs[i] - (hs[a] + t * (hs[b] - hs[a])));
      if (dev > worstDev) {
        worst = i;
        worstDev = dev;
      }
    }
    if (worst >= 0) {
      keep.add(worst);
      stack.push([a, worst], [worst, b]);
    }
  }
  return [...keep].sort((p, q) => p - q);
}
